export default __webpack_public_path__ + "static/media/home-business-slider-img03.70092a81.jpg";